export default {
  'rtrck.msg.input.filter': {
    ko: '사용자, Composite Role, Single Role, T-Code 중 하나 이상의 조회 조건을 입력하십시오.',
    ja: 'ユーザー、コンポジットロール、シングルロール、Tコードのうち一つ以上の照会条件を入力してください。',
    en: 'Please, input one or more filter of User, Composite Role, Single Role, T-Code.',
  },
  'rtrck.stop': {
    ko: '수집중지',
    ja: '収集停止',
    en: 'Stop',
  },
  'rtrck.grid.title.crol.unassign': {
    ko: 'Unassigned composite roles',
    ja: '割り当てられていないコンポジットロール',
    en: 'Unassigned composite roles',
  },
  'rtrck.auth.label.inactive': {
    ko: 'Inactive',
    ja: 'インアクティブ',
    en: 'Inactive',
  },
  'rtrck.tooltip.delete.saved.filter': {
    ko: '저장된 필터 삭제',
    ja: '保存したフィルターを削除',
    en: 'Delete saved filter',
  },
  'rtrck.grid.title.user.idle': {
    ko: 'Idle (Dormant) users',
    en: 'Idle (Dormant) users',
  },
  'rtrck.tooltip.filter.expand': {
    ko: '필터 펼치기',
    ja: 'フィルターを展開',
    en: 'Expand filters',
  },
  'rtrck.msg.input.filter.name': {
    ko: '저장할 필터의 이름을 입력하십시오.',
    ja: '保存するフィルター名を入力してください。',
    en: 'Please, input the name for saving filter.',
  },
  'rtrck.grid.title.sprf.unassign': {
    ko: 'Unassigned single profiles',
    ja: '割り当てられていないシングルプロファイル',
    en: 'Unassigned single profiles',
  },
  'rtrck.field.title.lock.status': {
    ko: 'Locked status',
    ja: 'ロックされたステータス',
    en: 'Locked status',
  },
  // BEGIN::Added.by.KWShin.2026.05.11.
  'rtrck.field.title.pwd.state': {
    ko: 'Password state',
    en: 'Password state',
  },
  'rtrck.field.title.last.logon': {
    ko: 'Last logon date',
    en: 'Last logon date',
  },
  // FINISH::Added.by.KWShin.2026.05.11.
  'rtrck.field.title.user.type': {
    ko: 'Type',
    ja: 'タイプ',
    en: 'Type',
  },
  'rtrck.grid.title.user.unchange': {
    ko: 'Unchanged password',
    ja: '変更されなかったパスワード',
    en: 'Unchanged password',
  },
  'rtrck.field.title.mandt': {
    ko: 'Client No.',
    ja: 'クライアント番号',
    en: 'Client No.',
  },
  'rtrck.tooltip.filter.reset': {
    ko: '필터값 모두 초기화',
    ja: '全てのフィルター値をリセット',
    en: 'Initialize filter value all',
  },
  'rtrck.tooltip.filter.save': {
    ko: '필터값 저장',
    ja: 'フィルター値を保存',
    en: 'Save filter value',
  },
  'rtrck.tab.title.menu': {
    ko: 'Menu',
    ja: 'メニュー',
    en: 'Menu',
  },
  'rtrck.grid.title.srol.unassign': {
    ko: 'Unassigned single roles',
    ja: '割り当てられていないシングルロール',
    en: 'Unassigned single roles',
  },
  'rtrck.grid.title.cprf.missing': {
    ko: 'Missing single profiles',
    ja: '欠落されたシングルプロファイル',
    en: 'Missing single profiles',
  },
  'rtrck.tab.title.profile': {
    ko: 'Profile',
    ja: 'プロファイル',
    en: 'Profile',
  },
  'rtrck.finish.datetime': {
    ko: '종료 일시',
    ja: '終了日時',
    en: 'Finished datetime',
  },
  'rtrck.field.title.role.status': {
    ko: '상태',
    ja: '状態',
    en: 'Status',
  },
  'rtrck.title.search.detail': {
    ko: 'Role Tracker Search Detail',
    ja: 'ロールトラッカー検索詳細',
    en: 'Role Tracker Search Detail',
  },
  'rtrck.title.last.logon.term': {
    ko: '최종 로그온 기간',
    ja: '最終のログオン日時',
    en: 'Term lastly logoned',
  },
  'rtrck.grid.title.cprf.total': {
    ko: 'Total composite profile',
    ja: 'コンポジットプロファイルの合計',
    en: 'Total composite profile',
  },
  'rtrck.tab.title.role': {
    ko: 'Role',
    ja: 'ロール',
    en: 'Role',
  },
  'rtrck.auth.label.maintained': {
    ko: 'All maintained',
    ja: '全て維持',
    en: 'All maintained',
  },
  'rtrck.collect.rate': {
    ko: '진행률',
    ja: '進行率',
    en: 'Running rate',
  },
  'rtrck.grid.title.crol.comparison': {
    ko: 'Required user comparison',
    ja: 'ユーザー比較が求められる',
    en: 'Required user comparison',
  },
  'rtrck.auth.label.missing.value': {
    ko: 'Missing value',
    ja: '欠落された値',
    en: 'Missing value',
  },
  'rtrck.msg.length.filter.name': {
    ko: '필터 이름은 32자리 이하이어야 합니다.',
    ja: 'フィルター名は32桁以下でなければならない',
    en: 'Filter name must be less than 32 character.',
  },
  'rtrck.title.sprf': {
    ko: 'Single Profile',
    ja: 'シングルプロファイル',
    en: 'Single Profile',
  },
  'rtrck.title.sstm': {
    ko: '시스템',
    ja: 'システム',
    en: 'System',
  },
  'rtrck.delete': {
    ko: '선택 내역 삭제',
    ja: '選択項目を削除',
    en: 'Delete selected',
  },
  'rtrck.data.set': {
    ko: '수집 데이터',
    ja: '収集データ',
    en: 'Collected data',
  },
  'rtrck.grid.title.sprf.total': {
    ko: 'Total single profile',
    ja: 'シングルプロファイルの合計',
    en: 'Total single profile',
  },
  'rtrck.msg.no.dataset': {
    ko: '수집된 데이터 셋이 존재하지 않습니다. 먼저 데이터를 수집해 주십시오.',
    ja: '収集されたデータセットが存在しません。まず、データを収集してください。',
    en: 'No data-set collected. Please, collect the data, first.',
  },
  'rtrck.field.title.agr.name': {
    ko: 'Role name',
    ja: 'ロール名',
    en: 'Role name',
  },
  'rtrck.grid.title.cprf.unassign': {
    ko: 'Unassigned composite profiles',
    ja: '割り当てられていないコンポジットプロファイル',
    en: 'Unassigned composite profiles',
  },
  'cd.053.U': {
    ko: 'Manual',
    ja: 'マニュアル',
    en: 'Manual',
  },
  'cd.053.S': {
    ko: 'Standard',
    ja: 'スタンダード',
    en: 'Standard',
  },
  'rtrck.confirm.collect': {
    ko: 'Role Tracker 데이터 수집에는 몇 십 분 정도의 시간이 소요됩니다. 수집하시겠습니까?',
    ja: 'ロールトラッカーのデータ収集には数十分かかることがあります。収集しますか？',
    en: 'It will be take a few ten minutes of time. Would you like to collect the data for Role Tracker?.',
  },
  'rtrck.grid.title.srol.missing': {
    ko: 'Missing corresponding profile',
    ja: '対応プロファイルの欠落',
    en: 'Missing corresponding profile',
  },
  'rtrck.tab.title.user': {
    ko: 'User',
    ja: 'ユーザー',
    en: 'User',
  },
  'rtrck.tooltip.filter.collapse': {
    ko: '필터 접기',
    ja: 'フィルターを折りたたむ',
    en: 'Collapse filters',
  },
  'cd.053.M': {
    ko: 'Modified',
    ja: '変更済み',
    en: 'Modified',
  },
  'rtrck.grid.title.srol.comparison': {
    ko: 'Required user comparison',
    ja: 'ユーザー比較が求められる',
    en: 'Required user comparison',
  },
  'rtrck.tab.title.authorization': {
    ko: 'Authorization',
    ja: '認可',
    en: 'Authorization',
  },
  'cd.053.G': {
    ko: 'Maintained',
    ja: '補修済み',
    en: 'Maintained',
  },
  'rtrck.title.upd.term': {
    ko: '수정 기간',
    ja: '更新日時',
    en: 'Term updated',
  },
  'rtrck.field.title.role.user.status': {
    ko: '사용자 상태',
    ja: 'ユーザー状態',
    en: 'User Status',
  },
  'rtrck.field.title.bname': {
    ko: 'User name',
    ja: 'ユーザー名',
    en: 'User name',
  },
  'rtrck.field.title.mod.datim': {
    ko: 'Updated date',
    ja: '更新日',
    en: 'Updated date',
  },
  'rtrck.grid.title.srol.total': {
    ko: 'Total single roles',
    ja: 'シングルロールの合計',
    en: 'Total single roles',
  },
  'rtrck.msg.input.entity.name': {
    ko: '조회할 대상의 이름을 입력하십시오.',
    ja: '照会する対象名を入力してください。',
    en: 'Please, input the name of entity.',
  },
  'rtrck.field.title.created.by': {
    ko: 'Created by',
    ja: '更新者',
    en: 'Created by',
  },
  'rtrck.confirm.filter.delete': {
    ko: '선택하신 필터를 삭제하시겠습니까?',
    ja: '選択したフィルターを削除しますか？',
    en: 'Will you delete the selected filter?',
  },
  'rtrck.title.pass.chnage.term': {
    ko: '비번 변경 기간',
    ja: 'パスワード変更日時',
    en: 'Term changed password',
  },
  'rtrck.tab.title.tcode': {
    ko: 'T-Code',
    ja: 'Tコード',
    en: 'T-Code',
  },
  'rtrck.grid.title.crol.missing': {
    ko: 'Missing single roles',
    ja: 'シングルロールの欠落',
    en: 'Missing single roles',
  },
  'rtrck.grid.title.user.less': {
    ko: 'Less than 20% T-Code usage',
    ja: 'Tコードの使用率が20%未満',
    en: 'Less than 20% T-Code usage',
  },
  'rtrck.title.crol': {
    ko: 'Composite Role',
    ja: 'コンポジットロール',
    en: 'Composite Role',
  },
  'rtrck.grid.title.user.active': {
    ko: 'Active users',
    ja: 'アクティブユーザー',
    en: 'Active users',
  },
  'rtrck.system': {
    ko: '시스템',
    ja: 'システム',
    en: 'System',
  },
  'rtrck.ph.srol': {
    ko: 'Single role 조건 입력',
    ja: 'シングルロールの条件入力',
    en: 'Enter a Single role.',
  },
  'rtrck.collect.type': {
    ko: '구분',
    ja: '区分',
    en: 'Type',
  },
  'rtrck.field.title.profn': {
    ko: 'Profile name',
    ja: 'プロファイル名',
    en: 'Profile name',
  },
  'rtrck.tab.title.assigned.user': {
    ko: 'Assigned user',
    ja: '割り当てられたユーザー',
    en: 'Assigned user',
  },
  'rtrck.title.lock.status': {
    ko: '잠금상태',
    ja: 'ロック状態',
    en: 'Lock status',
  },
  'rtrck.tooltip.filter.show': {
    ko: '필터 보이기',
    ja: 'フィルターを表示',
    en: 'Show filters',
  },
  'rtrck.tooltip.list.show': {
    ko: '목록 펼치기',
    ja: 'リストを展開',
    en: 'Expand list',
    cn: 'Expand list',
  },
  'rtrck.tooltip.list.hide': {
    ko: '목록 감추기',
    ja: 'リストを折りたたむ',
    en: 'Collapse list',
    cn: 'Collapse list',
  },
  'rtrck.title.crol.short': {
    ko: 'Comp. Role',
    ja: 'コンポ. ロール',
    en: 'Comp. Role',
    cn: 'Comp. Role',
  },
  'rtrck.title.cprf.short': {
    ko: 'Comp. Profile',
    ja: 'コンポ. プロファイル',
    en: 'Comp. Profile',
    cn: 'Comp. Profile',
  },
  'rtrck.ph.crol': {
    ko: 'Composite role 조건 입력',
    ja: 'コンポジットロールの条件入力',
    en: 'Enter a Composite role.',
  },
  'rtrck.grid.title.user.expire': {
    ko: 'Users with expired roles',
    ja: 'ロール期限の切れたユーザー',
    en: 'Users with expired roles',
  },
  'rtrck.title.updated.by': {
    ko: '수정자',
    ja: '更新者',
    en: 'Updated by',
  },
  'rtrck.collect': {
    ko: '수집',
    ja: '収集',
    en: 'Collect',
  },
  'rtrck.collect.datetime': {
    ko: '수집 일시',
    ja: '収集日時',
    en: 'Collected datetime',
  },
  'rtrck.msg.is.running': {
    ko: '이미 수집 중입니다.',
    en: 'Collecting job is running...',
    cn: 'Collecting job is running...',
    ja: 'すでに収集中です。',
  },
  'rtrck.title.summary.detail': {
    ko: 'Role Tracker Summary Detail',
    ja: 'ロールトラッカーのサマリー詳細',
    en: 'Role Tracker Summary Detail',
  },
  'rtrck.title.regist.term': {
    ko: '등록기간',
    ja: '登録期間',
    en: 'Term registered',
  },
  'rtrck.ph.tcod': {
    ko: 'T-Code 조건 입력',
    ja: 'Tコードの条件入力',
    en: 'Enter a T-Code.',
  },
  'rtrck.title.user': {
    ko: '사용자',
    ja: 'ユーザー',
    en: 'User',
  },
  'rtrck.title.cprf': {
    ko: 'Composite Profile',
    ja: 'コンポジットプロファイル',
    en: 'Composite Profile',
  },
  'rtrck.msg.stopped': {
    ko: '데이터 수집 작업이 중단되었습니다.',
    ja: 'データの収集作業を停止しました。',
    en: 'The batch process for collecting data was aborted.',
  },
  'rtrck.field.title.select.entity': {
    ko: '대상 선택',
    ja: '対象選択',
    en: 'Select entity',
  },
  'rtrck.title.registrant': {
    ko: '등록자',
    ja: '登録者',
    en: 'Registrant',
  },
  'rtrck.saved.filter': {
    ko: '저장된 필터 선택',
    ja: '保存されたフィルター選択',
    en: 'Select saved filter',
  },
  'rtrck.auth.label.missing.variable': {
    ko: 'Missing variable',
    ja: '変数欠落',
    en: 'Missing variable',
  },
  'rtrck.field.title.change.datim': {
    ko: 'Updated date',
    ja: '更新日',
    en: 'Updated date',
  },
  'rtrck.field.title.tcode.cnt': {
    ko: 'Tcode count',
    ja: 'Tコード数',
    en: 'Tcode count',
  },
  'rtrck.grid.title.srol.generation': {
    ko: 'Required profile greneration',
    ja: 'プロファイルの生成が求められる',
    en: 'Required profile greneration',
  },
  // BEGIN::Modified.by.KWShin.2026.05.11.
  // META_SAP_USER.UFLAG
  // 코드값이 없는 이 녀석은 select box에서 선택 조건으로 사용하기 위한 것임.
  'cd.039.': {
    ko: '모두',
    ja: '全て',
    en: 'All',
  },
  'cd.039.0': {
    ko: '정상',
    en: 'Not locked',
    ja: 'アンロック',
  },
  'cd.039.32': {
    // ko: 'Locked globally by administrator',
    // ja: '管理者による全体ロック',
    // en: 'Locked globally by administrator',
    ko: '관리자 잠금',
    en: 'Local locked',
  },
  'cd.039.64': {
    // ko: 'Locked locally by administrator',
    // ja: '管理者によるローカルなロック',
    // en: 'Locked locally by administrator',
    ko: '로그온 시도 초과',
    en: 'Password locked',
  },
  'cd.039.128': {
    // ko: 'Locked due to incorrect logons (limited term)',
    // ja: '不正なログオンのためロックされた(制限時間)',
    // en: 'Locked due to incorrect logons (limited term)',
    ko: '전역 잠금',
    en: 'Global locked',
  },
  // FINISH::Modified.by.KWShin.2026.05.11.
  // BEGIN::Added.by.KWShin.2026.05.11.
  // META_SAP_USER.PWDSTATE
  'cd.073.0': {
    ko: '정상',
    en: 'Normal',
  },
  'cd.073.1': {
    ko: '초기 비밀번호',
    en: 'Initial passwrod',
  },
  'cd.073.2': {
    ko: '비밀번호 만료',
    en: 'Expired',
  },
  'cd.073.3': {
    ko: '규정 미준수',
    en: 'Non-compliant',
  },
  'cd.073.253': {
    ko: '비밀번호 비활성화',
    en: 'Password deactivate',
  },
  'cd.073.254': {
    ko: '비밀번호 사용불가',
    en: 'Password disabled',
  },
  'cd.073.255': {
    ko: '비밀번호 없음',
    en: 'No password',
  },
  'cd.073.-1': {
    ko: '변경불가 (당일)',
    en: 'Change not allowed (same day)',
  },
  'cd.073.-2': {
    ko: '변경금지',
    en: 'Change forbidden',
  },
  // FINISH::Added.by.KWShin.2026.05.11.
  'rtrck.title.srol': {
    ko: 'Single Role',
    ja: 'シングルロール',
    en: 'Single Role',
  },
  'rtrck.field.title.modebe': {
    ko: 'Updated by',
    ja: '更新者',
    en: 'Updated by',
  },
  'rtrck.msg.is.erasing': {
    ko: '이미 삭제 중입니다.',
    ja: 'すでに削除中です。',
    en: 'Deleting job is running...',
  },
  'rtrck.grid.title.user.lock': {
    ko: 'Locked user',
    ja: 'ロックされたユーザー',
    en: 'Locked user',
  },
  'rtrck.title.tcod': {
    ko: 'T-Code',
    ja: 'Tコード',
    en: 'T-Code',
  },
  'rtrck.collect.status': {
    ko: '상태',
    ja: '状態',
    en: 'Status',
  },
  'rtrck.confirm.delete': {
    ko: '선택된 데이터 셋 모두가 삭제됩니다. 삭제하시겠습니까?',
    ja: '選択した全てのデータセットが削除されます。削除しますか？',
    en: 'All data in selected data-set will be erased. Would you like to delete?.',
  },
  'rtrck.grid.title.user.total': {
    ko: 'Total users',
    ja: 'ユーザーの合計',
    en: 'Total users',
  },
  'rtrck.field.title.change.usr': {
    ko: 'Updated by',
    ja: '更新者',
    en: 'Updated by',
  },
  'rtrck.field.title.valid.period': {
    ko: 'Valid period',
    ja: '有効期間',
    en: 'Valid period',
  },
  'rtrck.tooltip.filter.erase': {
    ko: '필터값 지우기',
    ja: 'フィルター値を削除する',
    en: 'Erase filter value',
  },
  'rtrck.ex.msg': {
    ko: '에러 메시지',
    en: 'Error mesage',
    cn: 'Error mesage',
    ja: 'Error mesage',
  },
  'rtrck.tooltip.filter.hide': {
    ko: '필터 감추기',
    ja: 'フィルターを非表示にする',
    en: 'Hide filters',
  },
  'rtrck.ph.user': {
    ko: '사용자 ID 조건 입력',
    ja: 'ユーザーIDの条件入力',
    en: 'Enter a User ID.',
  },
  'rtrck.tab.title.tcode.compare': {
    ko: 'T-Code compare',
    ja: 'Tコード比較',
    en: 'T-Code compare',
  },
  'rtrck.grid.title.crol.total': {
    ko: 'Total composite roles',
    ja: 'コンポジットロールの合計',
    en: 'Total composite roles',
  },
  'rtrck.exec.type.1': {
    ko: '수집',
    en: 'Collect',
    cn: 'Collect',
    ja: 'Collect',
  },
  'rtrck.exec.type.2': {
    ko: '삭제',
    en: 'Delete',
    cn: 'Delete',
    ja: 'Delete',
  },
};
